// extracted by mini-css-extract-plugin
module.exports = {"playerPanel_container":"style_playerPanel_container__1axOF","playerPanel_content":"style_playerPanel_content__z7ZH7","linePlayers":"style_linePlayers__3Dkr4"};